import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { FuseqHeaders } from '../../FuseQ/fuseq.headers'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'
@Injectable({
  providedIn: 'root'
})
export class AwpWFApiService {
  constructor (private readonly http: HttpClient, private readonly fuseqHeaders: FuseqHeaders) { }
  getAWPWorkflowType (): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpworkflow/getAWPWorkflowType`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getAWPWFHistory (id): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpworkflow/getAWPWFHistory?Id=${id}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getAWPListColumnsWorkflow (id): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpworkflow/getAWPListColumnsWorkflow?Id=${id}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getWorkflowJobRecord (id): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpworkflow/getWorkflowJobRecord/${id}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getWorkflowJobRecordClosed (id): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpworkflow/getWorkflowJobRecordClosed/${id}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  setStep (wfJobId, obj): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpworkflow/setStep/${wfJobId}`
    return this.http.post(APIEndPoint, obj, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  getWorkflowJobsList (filter): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpworkflow/getWorkflowJobsList?filterBy=${filter}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  saveNotes (obj): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpworkflow/saveNotes`
    return this.http.post(APIEndPoint, obj, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  notesList (id): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpworkflow/notesList/${id}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  getClosedWorkflowJobsList (filter): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpworkflow/getClosedWorkflowJobsList?filterBy=${filter}`
    return this.http.get(APIEndPoint, this.fuseqHeaders.setTokenHeaders('GET'))
  }

  Get_TotemMacAddress (obj): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpTotem/Get_TotemMacAddress`
    return this.http.post(APIEndPoint, obj, this.fuseqHeaders.setTokenHeaders('POST'))
  }

  CreateRequestRMA (obj): Observable<any> {
    const APIEndPoint = `${environment.API_URL}/awpworkflow/CreateRequestRMA`
    return this.http.post(APIEndPoint, obj, this.fuseqHeaders.setTokenHeaders('POST'))
  }
}
